import { useState } from "react"
import { ViewAdminBtn } from "./style"
import { ConfigProvider, message, Modal, Spin } from "antd"
import { activateStaff, deactivateStaff } from "services/AuthService"


const ADMIN_ROLES = {
    "lo": "Loan Officer",
    "lph": "Loan Processing Head",
    "acc": "Accountant",
    "la": "Auditor",
    "fdo": "Front Desk Officer",
    "blog": "Blogger",
    "es": "Executive Secretary"
}

export default function ShowStaffDetailsButton({ adminDetails,refetch }) {
    const [modalShown, setModalShown] = useState(false)
    const [deleteShown, setDeleteShown] = useState(false)
    const [suspendShown, setSuspendShown] = useState(false)
    const [suspendingAdmin, setSuspendingAdmin] = useState(false)

    const isSuspended = adminDetails.status === "deactivated" || adminDetails?.status === "suspended"


    const openModal = () => {
        setModalShown(true)
    }
    const closeModal = () => {
        setModalShown(false)
    }

    const suspendAdmin = async () => {
        try {
            const [, err] = await deactivateStaff({ id: adminDetails.id })
            if (err) {
                message.error(err.message)
                return;
            }
            message.success("Staff suspended successfully")
            setSuspendShown(false)
            closeModal()
            refetch()
        } finally {
            setSuspendingAdmin(false)
        }
    }
    const unsuspendAdmin = async () => {
        try {
            const [, err] = await activateStaff({ id: adminDetails.id })
            if (err) {
                message.error(err.message)
                return;
            }
            message.success("Staff activated successfully")
            setSuspendShown(false)
            closeModal()
            refetch()
        } finally {
            setSuspendingAdmin(false)
        }
    }

    const handleSuspendAdmin = async () => {
        setSuspendingAdmin(true)
        if (isSuspended) {
            await unsuspendAdmin()
            return;
        }
        await suspendAdmin()

    }


    return (
        <>
            <Modal open={modalShown} centered onCancel={closeModal} footer={null}>
                <div>
                    <p className="text-xl font-semibold">Staff Details</p>
                    <div className="grid my-6 gap-4">
                        <div>
                            <p className="font-medium">First Name</p>
                            <p>{adminDetails?.first_name || "N/A"}</p>
                        </div>
                        <div>
                            <p className="font-medium">Last Name</p>
                            <p>{adminDetails?.surname || "N/A"}</p>
                        </div>
                        <div>
                            <p className="font-medium">Email</p>
                            <p>{adminDetails.email}</p>
                        </div>
                        <div>
                            <p className="font-medium">Staff Position</p>
                            <p>{ADMIN_ROLES[adminDetails.admin_role]}</p>
                        </div>
                    </div>
                    <div className="flex items-center gap-x-4">
                        <button onClick={() => setSuspendShown(true)} className="bg-primary text-white px-5 py-2 rounded-lg">{isSuspended ? "Activate" : "Suspend"} Staff</button>
                        {/* <button onClick={() => setDeleteShown(true)} className="bg-red-400 rounded-lg text-white px-5 py-2">Remove Staff</button> */}
                    </div>
                </div>
            </Modal>
            <Modal open={deleteShown} onCancel={() => setDeleteShown(false)} centered footer={null}>
                <div className="text-center p-4">
                    <p className="text-xl font-semibold">Confirm Delete</p>
                    <p>Are you sure want to remove this admin, This cannot be reversed</p>
                    <div className="flex items-center gap-x-4 mt-5 justify-center">
                        <button onClick={() => setDeleteShown(false)} className="bg-primary text-white px-5 py-2 rounded-lg">Cancel</button>
                        <button className="bg-red-400 rounded-lg text-white px-5 py-2">Continue</button>
                    </div>
                </div>
            </Modal>
            <Modal open={suspendShown} onCancel={() => setSuspendShown(false)} centered footer={null}>
                <div className="text-center p-4">
                    <p className="text-xl font-semibold">Confirm {isSuspended ? "Activation" : "Suspension"}</p>
                    {isSuspended
                        ? <p>Are you sure want to activate this admin, This admin will be now be able to perform his actions freely</p>
                        : <p>Are you sure want to suspend this admin, This admin will be not able to perform his duties on active loans</p>

                    }
                    <div className="flex items-center gap-x-4 mt-5 justify-center">
                        <button onClick={() => setSuspendShown(false)} className="bg-primary text-white px-5 py-2 rounded-lg">Cancel</button>
                        <button disabled={suspendingAdmin} onClick={handleSuspendAdmin} className="bg-red-400 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed text-white px-5 py-2">
                            {
                                suspendingAdmin
                                    ? <ConfigProvider theme={{
                                        components: {
                                            Spin: {
                                                colorPrimary: "#ffffff",
                                            }
                                        }
                                    }}>
                                        <Spin />
                                    </ConfigProvider>
                                    : <span>Continue</span>
                            }
                        </button>
                    </div>
                </div>
            </Modal>
            <ViewAdminBtn
                status={"pending"}
                onClick={openModal}
            >
                <p className="text__value">View</p>
            </ViewAdminBtn>
        </>
    )
}